import { Button, Card } from "antd";
import styled from "styled-components";

export const LoginFormWrapper = styled.div`
background-image: linear-gradient(to bottom, #593c64, #cea4f8);
  opacity: 0.8;
  /* background-image: repeating-radial-gradient(
      circle at 0 0,
      transparent 0,
      #e5e5f7 10px
    ),
    repeating-linear-gradient(#cea4f8, #593c64); */
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
`;

export const LoginCard = styled(Card)`
  width: 40%;
  max-width: 900px;
  border: 3px solid #42005a;

  & .ant-card-head {
    border-bottom: none;
  }

  @media screen and (max-width: 900px) {
    width: 60%;
  }
  @media screen and (max-width: 500px) {
    width: 80%;
  }
`;
export const LogoImage = styled.img`
  height: 20px;
  width: auto;
`;

export const LoginButton = styled(Button)``;
